import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import ResultStatus from "../classes/ResultStatus" ;
import LabelWithInputField from "./LabelWithInputField" ;
import SuccessMessage from "../classes/SuccessMessage" ;
import EventBus from "../utils/EventBus" ;
import User from "../models/User" ;
import PageNavigator from "../classes/PageNavigator" ;
import UserRole from "../classes/UserRole" ;
import Result from "../classes/Result" ;
import Query from "../classes/Query" ;
import MessageDispatch from "../rocket/MessageDispatch" ;
import PopupWrapperView from "./PopupWrapperView" ;
import Button from "./Button" ;
import ListWrapper from "../utils/ListWrapper" ;
import UsersList from "../classes/UsersList" ;
import Company from "../models/Company" ;
import UsersListRequest from "../models/UsersListRequest" ;
import TextView from "./TextView" ;
import LabelDropdown from "./LabelDropdown" ;
import RPCServices from "../rpc/RPCServices" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import { Runnable } from "../classes/core" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;

type _CancelButtonOnPressed = ( d3eState : ChangeReportingManagerViewRefs ) => void ;

type _SaveButtonOnPressed = ( d3eState : ChangeReportingManagerViewRefs ) => void ;

type _LabelDropdownOnChanged = ( text : User,d3eState : ChangeReportingManagerViewRefs ) => void ;


  export  interface  ChangeReportingManagerViewProps extends  BaseUIProps {   key?: string ;
   user: User ;
 }
/// To store state data for ChangeReportingManagerView 
   class  ChangeReportingManagerViewRefs {  public cancelButton: CancelButtonState = new CancelButtonState() ;
  public saveButton: SaveButtonState = new SaveButtonState() ;
 }

   interface  SaveButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: ChangeReportingManagerViewRefs ;
   _onSaveHandler?: _SaveButtonOnPressed ;
 }

   class  SaveButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _SaveButtonWithState extends  ObservableComponent<SaveButtonWithStateProps> {   saveButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : SaveButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get saveButton (  ) : SaveButtonState {
 return this.props.d3eState.saveButton ; 
 }
  public get d3eState (  ) : ChangeReportingManagerViewRefs {
 return this.props.d3eState ; 
 }
  public get _onSaveHandler (  ) : _SaveButtonOnPressed {
 return this.props._onSaveHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('saveButton',null,this.saveButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'saveButton', 'saveButton.hover' ],this.rebuild);
 }
  public saveButtonOnEnter ( event ) : void {
 return this.saveButton.setHover(true) ; 
 }
  public saveButtonOnExit ( event ) : void {
 return this.saveButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.saveButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ child:Button({ padding:cStyle.tButtonPrimaryPaddingOn, decoration:cStyle.tButtonPrimaryDecorationOn, disable:this.saveButton.disable, onPressed:(  ) => {
 this._onSaveHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Save' }), onEnter:( event ) => {
 this.saveButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.saveButtonOnExit(event);
 }
 }), className:'Primary xa7' }) ; 
 }
 }
function SaveButtonWithState ( props : SaveButtonWithStateProps ) {
 return React.createElement(_SaveButtonWithState,props) ; 
 }


   interface  CancelButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: ChangeReportingManagerViewRefs ;
   _cancelButtonHandler?: _CancelButtonOnPressed ;
 }

   class  CancelButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _CancelButtonWithState extends  ObservableComponent<CancelButtonWithStateProps> {   cancelButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : CancelButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get cancelButton (  ) : CancelButtonState {
 return this.props.d3eState.cancelButton ; 
 }
  public get d3eState (  ) : ChangeReportingManagerViewRefs {
 return this.props.d3eState ; 
 }
  public get _cancelButtonHandler (  ) : _CancelButtonOnPressed {
 return this.props._cancelButtonHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('cancelButton',null,this.cancelButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'cancelButton', 'cancelButton.hover' ],this.rebuild);
 }
  public cancelButtonOnEnter ( event ) : void {
 return this.cancelButton.setHover(true) ; 
 }
  public cancelButtonOnExit ( event ) : void {
 return this.cancelButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.cancelButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ child:Button({ padding:cStyle.tButtonSecondaryPaddingOn, decoration:cStyle.tButtonSecondaryDecorationOn, disable:this.cancelButton.disable, onPressed:(  ) => {
 this._cancelButtonHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Cancel' }), onEnter:( event ) => {
 this.cancelButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.cancelButtonOnExit(event);
 }
 }), className:'Secondary x1ef' }) ; 
 }
 }
function CancelButtonWithState ( props : CancelButtonWithStateProps ) {
 return React.createElement(_CancelButtonWithState,props) ; 
 }


   class  _ChangeReportingManagerViewState extends  ObservableComponent<ChangeReportingManagerViewProps> {   static defaultProps = { user:null } ;
   d3eState: ChangeReportingManagerViewRefs = new ChangeReportingManagerViewRefs() ;
   userQuery: UsersList = null ;
   users: Array<User> = ListWrapper.widget(this,'users') ;
   filterdList: Array<User> = ListWrapper.widget(this,'filterdList') ;
  private _editInitListeners: Array<Runnable> = [ ] ;
  private _d3eModelErrors: Array<string> = [ ] ;
  private _firstNameErrors: Array<string> = [ ] ;
  private _lastNameErrors: Array<string> = [ ] ;
  private _emailErrors: Array<string> = [ ] ;
  public emailUniqueError: string ;
  private _passwordErrors: Array<string> = [ ] ;
  private _roleErrors: Array<string> = [ ] ;
  private _statusDefaultValue: boolean = true ;
  private _chatPageSizeDefaultValue: number = 10 ;
  private _acceptAutomationLeadsDefaultValue: boolean = false ;
  private _companyErrors: Array<string> = [ ] ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : ChangeReportingManagerViewProps ) {
 super(props);

this.initState();
 }
  public get user (  ) : User {
 return this.props.user ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('user',this.props.user);

this.computeUserQuery();

this.on([ 'userQuery', 'userQuery.items' ],this.computeUsers);

this.computeUsers();

this.on([ 'users', 'users.role' ],this.computeFilterdList);

this.computeFilterdList();

this.on([ 'filterdList', 'filterdList.firstName', 'filterdList.lastName', 'user', 'user.firstName', 'user.lastName', 'user.reportingManager' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : ChangeReportingManagerViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.user !== this.props.user ) {
 this.updateObservable('user',prevProps.user,this.props.user);

this.fire('user',this);
 }
 }
  public setUserQuery ( val : UsersList ) : void {
 let isValChanged :boolean=this.userQuery !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('userQuery',this.userQuery,val);

MessageDispatch.get().dispose(this.userQuery);

this.userQuery=val;

this.fire('userQuery',this);
 }
  public computeUserQuery  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setUserQuery(( await Query.get().getUsersList(UsageConstants.QUERY_GETUSERSLIST_CHANGEREPORTINGMANAGERVIEW_PROPERTIES_USERQUERY_COMPUTATION,new UsersListRequest(),{ 'synchronize':true })));
 }
 catch ( exception ) {
 console.log(' exception in computeUserQuery : ' + exception.toString());

this.setUserQuery(null);
 }
 }
  public setUsers ( val : Array<User> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.users,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('users',this.users,val);

this.users.clear();

this.users.addAll(val);

this.fire('users',this);
 }
  public addToUsers ( val : User,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.users.contains(val) ) this.users.add(val);
 }
 else {
 this.users.remove(this.users.elementAt(index));

this.users.add(val);
 }

this.fire('users',this,val,true);

this.updateObservable('users',null,val);
 }
  public removeFromUsers ( val : User ) : void {
 this.users.remove(val);

this.fire('users',this,val,false);

this.removeObservable('users',val);
 }
  public computeUsers  =  (  ) : void  =>  {
 try {
 this.setUsers(Array.from(this.userQuery?.items ?? [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeUsers : ' + exception.toString());

this.setUsers([  ]);
 }
 }
  public setFilterdList ( val : Array<User> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.filterdList,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('filterdList',this.filterdList,val);

this.filterdList.clear();

this.filterdList.addAll(val);

this.fire('filterdList',this);
 }
  public addToFilterdList ( val : User,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.filterdList.contains(val) ) this.filterdList.add(val);
 }
 else {
 this.filterdList.remove(this.filterdList.elementAt(index));

this.filterdList.add(val);
 }

this.fire('filterdList',this,val,true);

this.updateObservable('filterdList',null,val);
 }
  public removeFromFilterdList ( val : User ) : void {
 this.filterdList.remove(val);

this.fire('filterdList',this,val,false);

this.removeObservable('filterdList',val);
 }
  public computeFilterdList  =  (  ) : void  =>  {
 try {
 this.setFilterdList(Array.from(this.users.where(( u ) => u.role !== UserRole.SalesPerson)));
 }
 catch ( exception ) {
 console.log(' exception in computeFilterdList : ' + exception.toString());

this.setFilterdList([  ]);
 }
 }
  public get d3eModelErrors (  ) : Array<string> {
 return this._d3eModelErrors?? [] ; 
 }
  public set d3eModelErrors ( val : Array<string> ) {
 this._d3eModelErrors.clear();

this._d3eModelErrors.addAll(val);
 }
  public get firstNameErrors (  ) : Array<string> {
 return this._firstNameErrors?? [] ; 
 }
  public set firstNameErrors ( val : Array<string> ) {
 this._firstNameErrors.clear();

this._firstNameErrors.addAll(val);
 }
  public async computeFirstNameErrors (  ) : Promise<void> {
 this.firstNameErrors=[ ];

let it :string=this.user.firstName;

if ( it == null || it === '' ) {
 this.firstNameErrors.add('First Name cannot be empty.');
 }

this.fire('firstNameErrors',this);
 }
  public get lastNameErrors (  ) : Array<string> {
 return this._lastNameErrors?? [] ; 
 }
  public set lastNameErrors ( val : Array<string> ) {
 this._lastNameErrors.clear();

this._lastNameErrors.addAll(val);
 }
  public async computeLastNameErrors (  ) : Promise<void> {
 this.lastNameErrors=[ ];

let it :string=this.user.lastName;

if ( it == null || it === '' ) {
 this.lastNameErrors.add('Last Name cannot be empty.');
 }

this.fire('lastNameErrors',this);
 }
  public get emailErrors (  ) : Array<string> {
 return this._emailErrors?? [] ; 
 }
  public set emailErrors ( val : Array<string> ) {
 this._emailErrors.clear();

this._emailErrors.addAll(val);
 }
  public async computeEmailErrors (  ) : Promise<void> {
 this.emailErrors=[ ];

let it :string=this.user.email;

if ( it == null || it === '' ) {
 this.emailErrors.add('Email cannot be empty.');
 }

this.fire('emailErrors',this);
 }
  public async checkUserEmailUniqueInCompany (  ) : Promise<void> {
 if ( this.user == null || this.user.company == null ) {
 return ; 
 }

let isUnique :boolean=( await RPCServices.getUniqueChecker().checkUserEmailUniqueInCompany(this.user.company,this.user,this.user.email));

if ( !isUnique ) {
 this.emailUniqueError='Duplicate email found with this value.';
 }
 }
  public get passwordErrors (  ) : Array<string> {
 return this._passwordErrors?? [] ; 
 }
  public set passwordErrors ( val : Array<string> ) {
 this._passwordErrors.clear();

this._passwordErrors.addAll(val);
 }
  public async computePasswordErrors (  ) : Promise<void> {
 this.passwordErrors=[ ];

let it :string=this.user.password;

if ( it == null || it === '' ) {
 this.passwordErrors.add('Password cannot be empty.');
 }

this.fire('passwordErrors',this);
 }
  public get roleErrors (  ) : Array<string> {
 return this._roleErrors?? [] ; 
 }
  public set roleErrors ( val : Array<string> ) {
 this._roleErrors.clear();

this._roleErrors.addAll(val);
 }
  public async computeRoleErrors (  ) : Promise<void> {
 this.roleErrors=[ ];

let it :UserRole=this.user.role;

this.fire('roleErrors',this);
 }
  public get companyErrors (  ) : Array<string> {
 return this._companyErrors?? [] ; 
 }
  public set companyErrors ( val : Array<string> ) {
 this._companyErrors.clear();

this._companyErrors.addAll(val);
 }
  public async computeCompanyErrors (  ) : Promise<void> {
 this.companyErrors=[ ];

let it :Company=this.user.company;

if ( it == null ) {
 this.companyErrors.add('Company cannot be null.');
 }

this.fire('companyErrors',this);
 }
  public setEditDefaults (  ) : void {
  }
  public get isEditValid (  ) : boolean {
 if ( this.firstNameErrors.isNotEmpty ) {
 return false ; 
 }

if ( this.lastNameErrors.isNotEmpty ) {
 return false ; 
 }

if ( this.emailErrors.isNotEmpty ) {
 return false ; 
 }

if ( this.passwordErrors.isNotEmpty ) {
 return false ; 
 }

if ( this.roleErrors.isNotEmpty ) {
 return false ; 
 }

if ( this.companyErrors.isNotEmpty ) {
 return false ; 
 }

return true ; 
 }
  public validate (  ) : Array<string> {
 let errors :Array<string>=[ ];

this.computeFirstNameErrors();

errors.addAll(this.firstNameErrors);

this.computeLastNameErrors();

errors.addAll(this.lastNameErrors);

this.computeEmailErrors();

errors.addAll(this.emailErrors);

this.computePasswordErrors();

errors.addAll(this.passwordErrors);

this.computeRoleErrors();

errors.addAll(this.roleErrors);

this.computeCompanyErrors();

errors.addAll(this.companyErrors);

return errors ; 
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return PopupWrapperView({ title:'Change Reporting Manager', content:ui.Column({ children:[ LabelWithInputField({ name:'Employee Name', value:this.user.firstName + ' ' + this.user.lastName, disable:true, className:'x161 hc h', key:'0' }), LabelDropdown<User>({ name:'Reporting Manager', placeHolder:'Select Reporting Manager', value:this.user.reportingManager, items:this.filterdList, onChanged:( text ) => {
 this.labelDropdownonChanged(text,this.d3eState);
 }
, builder:( context,item ) => {
 return TextView({ data:item.firstName + ' ' + item.lastName }) ; 
 }
, className:'x45 hc h', key:'1' }) ], className:'x3d0 hc h' }), buttons:[ CancelButtonWithState({ d3eState:this.d3eState, _cancelButtonHandler:this.cancelButtonHandler, key:'0' }), SaveButtonWithState({ d3eState:this.d3eState, _onSaveHandler:this.onSaveHandler, key:'1' }) ], className:ui.join('ChangeReportingManagerView hc vc ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onInit  =  (  ) : void  =>  {
  }
  public cancelButtonHandler  =  ( d3eState : ChangeReportingManagerViewRefs ) : void  =>  {
 this.user.restore();

this.navigator.close();
 }
  public onSaveHandler  =  async  ( d3eState : ChangeReportingManagerViewRefs ) : Promise<void>  =>  {
 if ( this.validate().isEmpty ) {
 let result :Result<User>=( await this.user.save());

if ( result.status === ResultStatus.Success ) {
 EventBus.get().fire(new SuccessMessage({ message:'Successfully Saved' }));

this.navigator.close();
 }
 }
 }
  public dispose (  ) : void {
 MessageDispatch.get().dispose(this.userQuery);

super.dispose();
 }
  public labelDropdownonChanged  =  ( val : User,d3eState : ChangeReportingManagerViewRefs ) : void  =>  {
 this.user.setReportingManager(val);
 }
  public get navigator (  ) : PageNavigator {
 return PageNavigator.of(this.context) ; 
 }
  public get cancelButton (  ) {
 return this.d3eState.cancelButton ; 
 }
  public get saveButton (  ) {
 return this.d3eState.saveButton ; 
 }
 }
export default function ChangeReportingManagerView ( props : ChangeReportingManagerViewProps ) {
 return React.createElement(_ChangeReportingManagerViewState,{ ..._ChangeReportingManagerViewState.defaultProps, ...props }) ; 
 }
